var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "View",

    getDefaultProps () {
        return {"width":"13px","height":"14px","viewBox":"0 0 13 14","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>F877180C-F97F-41C4-8257-520C2D252BA5</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Header-01-EventGroup" transform="translate(-916.000000, -271.000000)" fill="currentColor">
      <g id="Group" transform="translate(899.000000, 259.000000)">
        <g id="Group-13">
          <g id="view" transform="translate(17.000000, 12.000000)">
            <path d="M5,0.448046425 C4.99975479,0.0500898156 4.59657532,-0.149526741 4.35995261,0.131155151 L0.110605936,5.17173073 C-0.0366043846,5.34635163 -0.036906998,5.63030132 0.109930651,5.80536767 L4.35626767,10.8680387 C4.59271031,11.1499361 4.99699045,10.9502849 4.99699045,10.5516218 L4.99699073,7.36307432 C4.99699073,7.11593732 4.82895124,6.91559319 4.62166402,6.91559319 C4.4143768,6.91559319 4.24633731,7.11593732 4.24633731,7.36307432 L4.24633702,10.5516218 L4.8870598,10.2352048 L0.640722779,5.17253379 L0.640047493,5.80617073 L4.88939417,0.765595155 L4.24934678,0.448703881 L4.24633751,3.37574823 C4.24648979,3.62288517 4.41465268,3.82308206 4.62193984,3.82290051 C4.82922701,3.82271896 4.99714301,3.62222771 4.99699073,3.37509077 L5,0.448046425 L5,0.448046425 Z M7.79956969,3.8806735 C10.5997996,3.88804029 12.1879667,5.64661059 12.199931,7.84482347 L12.1999435,13.5636541 L12.9937082,13.4825294 C12.9644065,13.3030612 12.8957614,13.0048339 12.77496,12.6266048 C12.5749817,12.0004733 11.7998982,6.9625868 8.23974253,6.9625868 C8.14670157,6.9625868 8.14670157,6.9625868 8.05285781,6.96258681 C7.9126744,6.96258683 7.9126744,6.96258683 7.77516701,6.96258685 C7.57018186,6.96258688 5.62229744,6.96258678 5.43936614,6.9625868 C5.2184341,6.9625868 5.03933329,7.1594215 5.0393333,7.40222939 C5.03933331,7.64503728 5.21843412,7.84187196 5.43936616,7.84187195 C5.62229755,7.84187193 7.57018198,7.84187204 7.77516714,7.841872 C7.91267451,7.84187198 7.91267451,7.84187198 8.05285788,7.84187196 C8.14670161,7.84187195 8.14670161,7.84187195 8.23974253,7.84187195 C10.9683131,7.84187195 11.8425306,12.3620125 12.0200497,12.9178245 C12.0820114,13.1118264 12.1307179,13.2913228 12.1675425,13.4513066 C12.188979,13.5444371 12.2013952,13.6082759 12.2062196,13.6378245 C12.2927526,14.1678254 13.0038593,14.0951485 12.9999842,13.5566998 C12.9999842,13.5566998 12.9952329,11.2412585 12.9976148,7.84482347 C12.9999967,4.44838844 10.5997996,3.00867738 7.81618027,3.00447718 C5.0325609,3.00027698 5.50630464,3.0000163 5.40003284,3 C5.1791008,3.00000001 5,3.1968347 5,3.43964259 C5,3.68245047 5.17910082,3.87928516 5.40003286,3.87928515 C5.5061482,3.87930143 7.79096581,3.88065087 7.79956969,3.8806735 L7.79956969,3.8806735 L7.79956969,3.8806735 Z" id="Rectangle-449" transform="translate(6.500000, 7.000000) scale(-1, 1) translate(-6.500000, -7.000000) "/>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/view.svg
 **/